import { render, staticRenderFns } from "./LoadingMessage.vue?vue&type=template&id=a5080fde&scoped=true"
import script from "./LoadingMessage.vue?vue&type=script&lang=js"
export * from "./LoadingMessage.vue?vue&type=script&lang=js"
import style0 from "./LoadingMessage.vue?vue&type=style&index=0&id=a5080fde&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5080fde",
  null
  
)

export default component.exports